const Term = Object.freeze({
    TermsOfUse: "TOU_LAUNDRYINST",
    PrivacyPolicy: "PRV_LAUNDRYINST",
});

export default Term;
